import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeGetClustersKeysResponseDataSchema,
  DataResponse,
  GetBackofficeClusterKeysSchema,
} from "schema"
import { z } from "zod"

type Query = z.input<typeof GetBackofficeClusterKeysSchema>
type Response = DataResponse<z.infer<typeof BackofficeGetClustersKeysResponseDataSchema>>
type OnSuccessFn = (data: Response) => void

const getBackofficeClusterKeysQueryKey = (query: Query) => ["backofficeClusterKeys", query]

type Props = {
  query: Query
  onSuccess?: OnSuccessFn
}

export const getBackofficeClusterKeysQuery = ({ query, onSuccess }: Props) => {
  return queryOptions({
    queryKey: getBackofficeClusterKeysQueryKey(query),
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/clusters", {
        params: query,
      })
      onSuccess?.(data)
      return data.data
    },
  })
}
